import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.css']
})
export class EulaComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
    const downLink = document.createElement('a');
          downLink.href = '../assets/documents/Clover EULA for Stellar ScaleTech Card Payments 2025-7-10.pdf';
          downLink.click();
          window.open(downLink.href, '_blank');
  }

}
